export const PEOPLE_RISK_ASSESSEMENT_ERROR_CODE = '22.18';

export const RESCTRICTED_ZIP_CODE_ERROR_CODE = '22.06';
export const RESCTRICTED_CITY_CODE_ERROR_CODE = '22.15';
export const RESCTRICTED_STATE_ERROR_CODE = '22.22';

export const CHECK_EXPOSURE_ERROR_CODE = '21.25';

export const BROKER_URLS = ['/xp', '/gallagher', '/coopercitrus'];
